import { useEffect, useMemo, useState } from "react";
import { SETTINGS_CONFIG } from "../constants/settings.constants";
import { getGobalSettings } from "../api/settings.api";
import { GobalSettings } from "../types/settings.types";

const useSettings = () => {
  const [globalSettings, setGlobalSettings] = useState<GobalSettings | null>(
    null,
  );

  useEffect(() => {
    const fetchGlobalSettings = async () => {
      try {
        const response = await getGobalSettings();
        if (response?.success) setGlobalSettings(response.data);
      } catch (err) {
        console.error("Error fetching global settings:", err);
      }
    };
    fetchGlobalSettings();
  }, []);

  const birthYearOptions = useMemo((): string[] => {
    if (!globalSettings) return [];

    const min = parseInt(globalSettings[SETTINGS_CONFIG.BIRTH_YEAR_MIN]);
    const max = parseInt(globalSettings[SETTINGS_CONFIG.BIRTH_YEAR_MAX]);
    const gap = parseInt(globalSettings[SETTINGS_CONFIG.BIRTH_DATE_GAP]);

    const options = [`Before ${min}`];

    for (let i = min; i <= max; i += gap) {
      const label = `${i} - ${i + gap - 1}`;
      options.push(label);
    }

    return options;
  }, [globalSettings]);

  const genderOptions = useMemo((): string[] => {
    if (!globalSettings) return [];
    return globalSettings[SETTINGS_CONFIG.GENDER]?.split(",") || [];
  }, [globalSettings]);

  const raceOptions = useMemo((): string[] => {
    if (!globalSettings) return [];
    return globalSettings[SETTINGS_CONFIG.RACE]?.split(",") || [];
  }, [globalSettings]);

  return { birthYearOptions, genderOptions, raceOptions };
};

export default useSettings;
